import Vue from 'vue';
import Component from 'vue-class-component';
import { ItiIconButton } from '@/iti-core-vuetify';
import { Prop } from 'vue-property-decorator';
import { Reply } from '../../../shared/dtos/reply';
import { confirm } from 'devextreme/ui/dialog';
import replyModule from '../../../store/modules/reply.module';
import { itiMessageService } from '@/iti-core-vue';

@Component({
  components: {
    ItiIconButton,
  },
})
export default class PostComponent extends Vue {
  @Prop() public reply!: Reply;
  @Prop() public openEditor!: Function;

  public deleteReply() {
    itiMessageService.confirm('¿Está seguro de que desea borrar esta respuesta?', this.$tc('mensajes.confirmar'), (result) => {
      if(result) {
        replyModule.deleteReply(this.reply.id)
          .then(() => itiMessageService.toast('Se ha borrado la respuesta', 'success', 3000))
          .catch(() => itiMessageService.toast('No se ha podido borrar la respuesta', 'error', 3000));
      }
    });
  }

  public editReply() {
    this.openEditor(this.reply);
  }
}